<template>
  <div class="dashboard__view">
    <div class="page">
      <!--filter start-->
      <div class="relative">
        <div class="text-light">
          <p>
            Filter by :
            <span @click="openFilters = !openFilters">
              {{
                tabSelected !== "approvedRequests"
                  ? tabSelected === "pendingRequests"
                    ? "Pending Approvals"
                    : "Declined Requests"
                  : "Processed Approvals"
              }}
              <svg
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="openFilters ? '' : 'rotate'"
              >
                <path
                  d="M1 1L5 5L9 1"
                  stroke="#e00b5b"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </p>
        </div>
        <div class="filter-dropdown" v-if="openFilters">
          <div class="filter-title">
            {{
              tabSelected !== "approvedRequests"
                ? tabSelected === "pendingRequests"
                  ? "Pending Approvals"
                  : "Declined Requests"
                : "Processed Approvals"
            }}
          </div>
          <div class="form__item">
            <input
              class="form__input"
              type="text"
              v-model="filterList.reference"
              placeholder="Reference"
            />
          </div>
          <div class="form__item">
            <Dropdown
              title="Source Account"
              :label="
                filterList.destinationAccountNumber
                  ? displayBankDetails(filterList.destinationAccountNumber)
                  : 'Select Account'
              "
              :options="accountDropdownOptions"
              :useModalDataToggle="false"
              :onOptionSelected="
                ({ payload }) => {
                  filterList.destinationAccountNumber = payload.accountNumber;
                }
              "
            />
          </div>
          <div class="">
            <p class="filter-title">STATUS</p>
            <div
              v-for="status in statusGroup"
              class="status-element"
              :key="status.id"
              @click="() => (filterList.status = status.id)"
            >
              <p v-if="status.id === filterList.status">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="8" fill="#e00b5b" />
                  <path
                    d="M11 6L6.875 10L5 8.18182"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </p>
              <p v-else>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="7.5" stroke="#979797" />
                </svg>
              </p>
              <p class="filter-title">{{ status.name }}</p>
            </div>
          </div>
          <div>
            <p class="filter-title">Date</p>
            <div class="date-group">
              <div class="">
                <input
                  placeholder="Request Date"
                  class="date margin-right"
                  type="text"
                  onfocus="(this.type='date')"
                  id="date"
                  v-model="filterList.requestDate"
                />
              </div>
              <div class="">
                <input
                  placeholder="Approval Date"
                  class="date"
                  type="text"
                  onfocus="(this.type='date')"
                  id="date"
                  v-model="filterList.approvalDate"
                />
              </div>
            </div>
          </div>
          <div class="button-group">
            <button
              class="btn woven-border-only woven-red"
              @click="clearFilter(false)"
            >
              Reset Filter
            </button>
            <button class="btn woven-color" @click="triggerFilter">
              <p>Filter</p>
            </button>
          </div>
        </div>
      </div>
      <!--filter end-->

      <div class="page__title"></div>
      <div class="page__title__action">
        <button
          class="btn btn--primary"
          @click="() => $router.push({ name: 'transfers-initiate' })"
          v-if="showInitiateButton"
        >
          Initiate Transfer
        </button>
      </div>
    </div>
    <div class="overview">
      <template v-if="collectionAccountsLoading">
        <account-card :loading="true" v-for="n in 7" :key="n" />
      </template>

      <main class="overview" v-else>
        <account-card
          @click="() => {}"
          :isActive="true"
          :isPrimary="true"
          :amount="'₦' + formatAmount(summary.cumulative_balance) || 'N/A'"
          :account="`(${summary.fetch_summary})`"
          name="Cummulative Balance"
          :useNameTooltip="false"
          :useActiveStatusIndicator="false"
        />

        <main class="overview">
          <account-card
            @click="() => {}"
            v-for="account in collectionAccounts"
            :key="account.accountNumber"
            :isActive="true"
            :amount="
              account.balance >= 0 ? '₦' + formatAmount(account.balance) : 'N/A'
            "
            :account="`(${account.accountNumber})`"
            :sourceUrl="`https://cdn.jsdelivr.net/gh/wovenfinance/cdn@main/logos/${account.bankCode}.png`"
            :name="account.bankName"
            :useNameTooltip="false"
            :useActiveStatusIndicator="false"
          />
        </main>
      </main>
    </div>

    <div class="list">
      <div class="tab">
        <router-link
          tag="div"
          to="/dashboard/transfers?page=1&request_status=APPROVED"
          :class="{ active: tabSelected == 'approvedRequests' }"
          class="tab__item"
        >
          Approved
        </router-link>

        <router-link
          to="/dashboard/transfers?page=1&request_status=PENDING"
          tag="div"
          :class="{ active: tabSelected == 'pendingRequests' }"
          class="tab__item"
        >
          Pending
        </router-link>

        <router-link
          to="/dashboard/transfers?page=1&request_status=DECLINED"
          tag="div"
          :class="{ active: tabSelected == 'declinedRequests' }"
          class="tab__item"
        >
          Declined
        </router-link>
      </div>

      <div class="tab__content">
        <EmptyState v-if="noRequests" type="pendingApprovals" />

        <div v-else>
          <!-- Loader -->
          <div class="loader" v-if="fetchingRequests">
            <span aria-hidden="true" class="spinner-border"></span>
          </div>

          <template v-else>
            <table
              class="table card-table vgt-table"
              v-if="
                tabSelected == 'approvedRequests' ||
                tabSelected == 'declinedRequests'
              "
            >
              <thead>
                <tr>
                  <th v-if="tabSelected == 'approvedRequests'"></th>
                  <th>PAYMENT REFERENCE</th>
                  <th>INVITATION DATE</th>
                  <th>SOURCE ACCOUNT</th>
                  <th>DESTINATION ACCOUNT</th>
                  <th style="text-align: left">AMOUNT</th>
                </tr>
              </thead>
              <tbody>
                <router-link
                  :key="item.id"
                  :to="{
                    name: 'transfers-details',
                    params: { reference: item.transactionReference },
                  }"
                  tag="tr"
                  v-for="item in requests"
                >
                  <td v-if="tabSelected == 'approvedRequests'">
                    <status-indicator :type="item.transactionStatus" />
                  </td>
                  <td>
                    <span class="name">{{ item.transactionReference }}</span>
                  </td>
                  <td>
                    <span class="name">{{
                      moment(item.createdAt ? item.createdAt : "").format("lll")
                        | availability
                    }}</span>
                    <span class="email">{{
                      moment(item.createdAt ? item.createdAt : "").format("LT")
                    }}</span>
                  </td>
                  <td>
                    <span class="name">{{
                      item.sourceAccountNumber | availability
                    }}</span>
                    <span class="email">{{
                      item.sourceBankName | availability
                    }}</span>
                  </td>
                  <td>
                    <span class="name">{{
                      item.destinationAccountNumber | availability
                    }}</span>
                    <span class="email">{{
                      item.destinationBankName | availability
                    }}</span>
                  </td>
                  <td style="text-align: left">
                    ₦{{ formatAmount(item.amount) }}
                  </td>
                </router-link>
              </tbody>
            </table>

            <table class="table card-table vgt-table" v-else>
              <thead>
                <tr>
                  <th>REQUESTER</th>
                  <th>REQUEST DATE</th>
                  <th>SOURCE ACCOUNT</th>
                  <th>DESTINATION ACCOUNT</th>
                  <th>AMOUNT</th>
                  <th style="text-align: center">STATUS</th>
                </tr>
              </thead>
              <tbody>
                <router-link
                  :key="item.id"
                  :to="{
                    name: 'transfers-details',
                    params: { reference: item.transactionReference },
                  }"
                  tag="tr"
                  v-for="item in requests"
                >
                  <td
                    style="max-width: 140px !important; word-break: break-all"
                  >
                    <span class="name">{{
                      item.requesterName | availability
                    }}</span>
                    <span class="email">{{
                      item.requesterEmail ? item.requesterEmail : ""
                    }}</span>
                  </td>
                  <td>
                    <span class="name">{{
                      moment(item.createdAt ? item.createdAt : "").format("lll")
                    }}</span>
                    <span class="email">{{
                      moment(item.createdAt ? item.createdAt : "").format("LT")
                    }}</span>
                  </td>
                  <td>
                    <span class="name">{{ item.sourceAccountNumber }}</span>
                    <span class="email">{{ item.sourceBankName }}</span>
                  </td>
                  <td>
                    <span class="name">{{
                      item.destinationAccountNumber
                    }}</span>
                    <span class="email">{{ item.destinationBankName }}</span>
                  </td>
                  <td style="text-align: left">
                    ₦{{ formatAmount(item.amount) }}
                  </td>
                  <td class="act">
                    <b-dropdown
                      v-if="item.requesterEmail !== userDetails.email"
                      right
                      size="sm"
                      text="Pending"
                      style="width: 200px"
                    >
                      <div
                        class="act__item dropdown-item-list green"
                        @click.stop="
                          openApproveModal($v, item.transactionReference)
                        "
                        v-if="showApproveButton"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="#15CE9A"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.19995 16V4"
                            stroke="#919EAB"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M2 7.42857L5.2 4L8.4 7.42857"
                            stroke="#919EAB"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14.8 4V16"
                            stroke="#919EAB"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M11.6001 12.5714L14.8001 16L18.0001 12.5714"
                            stroke="#919EAB"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>

                        <span>
                          <button class="btn--noStyle">Approve</button>
                        </span>
                      </div>

                      <div
                        class="act__item dropdown-item-list"
                        @click.stop="
                          openDeclineModal($v, item.transactionReference)
                        "
                        v-if="showApproveButton"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
                            stroke="#C61010"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4 5L15 16"
                            stroke="#C61010"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>

                        <span>
                          <button class="btn--noStyle red">Deny</button>
                        </span>
                      </div>
                    </b-dropdown>
                    <status-indicator-with-words
                      :type="item.requestStatus"
                      v-else
                      class="text-center"
                    />
                  </td>
                </router-link>
              </tbody>
            </table>
          </template>

          <div class="table__details" v-if="fetchingRequests !== true">
            <div class="table__details__left">
              <span class="text-muted" v-if="pageInfo.total"
                >Page {{ pageInfo.current_page ? pageInfo.current_page : 1 }} of
                {{ pageInfo.total_pages ? pageInfo.total_pages : 5 }}</span
              >
            </div>
            <div class="table__details__right">
              <Pagination
                :numberOfPages="pageInfo.total_pages ? pageInfo.total_pages : 5"
              />
            </div>
            <div class="table__details__right"></div>
          </div>
        </div>
      </div>
    </div>

    <!--  initiate transfer modal-->
    <extend-modal
      classes="justify-content-center"
      :toggle="toggleModal"
      v-if="showModal"
      :loading="submitting"
    >
      <div class="modal-body">
        <svg
          width="60"
          height="61"
          viewBox="0 0 60 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M57.5 27.501C56.12 27.501 55 28.621 55 30.001C55 43.786 43.785 55.001 30 55.001C16.215 55.001 5 43.786 5 30.001C5 16.216 16.215 5.00102 30 5.00102C34.57 5.00102 39.135 6.28102 43.0725 8.50352L39.8425 11.7335C39.1275 12.4485 38.9125 13.5235 39.3 14.4585C39.6875 15.391 40.6 16.001 41.6125 16.001H52.6125C53.9925 16.001 55.1125 14.881 55.1125 13.501V2.50102C55.1125 1.49102 54.5025 0.578524 53.57 0.191024C52.6325 -0.196477 51.56 0.0160235 50.845 0.733524L46.735 4.84352C41.815 1.75352 35.9825 0.00102351 30 0.00102351C13.4575 0.00102351 0 13.4585 0 30.001C0 46.5435 13.4575 60.001 30 60.001C46.5425 60.001 60 46.5435 60 30.001C60 28.621 58.88 27.501 57.5 27.501Z"
            fill="#e00b5b"
          />
          <path
            d="M46.25 30.001C46.25 38.976 38.975 46.251 30 46.251C21.025 46.251 13.75 38.976 13.75 30.001C13.75 21.026 21.025 13.751 30 13.751C38.975 13.751 46.25 21.026 46.25 30.001Z"
            fill="#e00b5b"
          />
          <path
            d="M36.8751 32.741C36.8751 31.396 36.2576 30.2085 35.3151 29.431C35.6851 28.791 35.9126 28.046 35.9126 27.241C35.9126 25.3385 34.6926 23.7435 33.0276 23.2085V21.501C33.0276 20.671 32.3826 20.001 31.5851 20.001C30.7876 20.001 30.1426 20.6735 30.1426 21.501V23.001H29.1801V21.501C29.1801 20.671 28.5351 20.001 27.7376 20.001C26.9401 20.001 26.2951 20.6735 26.2951 21.501V23.001H25.8151C25.0176 23.001 24.3726 23.6735 24.3726 24.501V30.001V35.501C24.3726 36.3285 25.0176 37.001 25.8151 37.001H26.2951V38.501C26.2951 39.331 26.9426 40.001 27.7376 40.001C28.5326 40.001 29.1801 39.3285 29.1801 38.501V37.001H30.1426V38.501C30.1426 39.331 30.7876 40.001 31.5851 40.001C32.3801 40.001 33.0276 39.3285 33.0276 38.501V36.976C35.1676 36.8485 36.8751 35.016 36.8751 32.741ZM27.2601 26.001H31.8376C32.4951 26.001 33.0301 26.5585 33.0301 27.261C33.0301 27.9435 32.4951 28.501 31.8376 28.501H27.2601V26.001ZM32.7976 34.001H27.2601V31.501H31.8376H32.8001C33.4576 31.501 33.9926 32.0585 33.9926 32.761C33.9901 33.4435 33.4551 34.001 32.7976 34.001Z"
            fill="#B6E4E9"
          />
          <path
            d="M30.0024 0.00366211H29.5274C13.3599 0.253662 0.252441 13.3587 0.00244141 29.5287V30.4737C0.257441 46.7987 13.6149 60.0012 29.9999 60.0012H30.0024V55.0012H29.9999C16.2149 55.0012 4.99994 43.7862 4.99994 30.0012C4.99994 16.2162 16.2149 5.00116 29.9999 5.00116H30.0024V0.00366211Z"
            fill="#FFDADB"
          />
          <path
            d="M30.0025 31.501H27.2575V34.001H30.0025V31.501ZM30.0025 26.001H27.2575V28.501H30.0025V26.001ZM30 13.751C21.025 13.751 13.75 21.026 13.75 30.001C13.75 38.976 21.025 46.251 30 46.251H30.0025V37.001H29.18V38.501C29.18 39.331 28.535 40.001 27.7375 40.001C26.94 40.001 26.295 39.3285 26.295 38.501V37.001H25.815C25.0175 37.001 24.3725 36.3285 24.3725 35.501V30.001V24.501C24.3725 23.6735 25.0175 23.001 25.815 23.001H26.295V21.501C26.295 20.671 26.9425 20.001 27.7375 20.001C28.5325 20.001 29.18 20.6735 29.18 21.501V23.001H30.0025V13.751H30Z"
            fill="#FFDADB"
          />
          <path
            d="M27.74 20.001C26.945 20.001 26.2975 20.6735 26.2975 21.501V23.001H25.8175C25.02 23.001 24.375 23.6735 24.375 24.501V30.001V35.501C24.375 36.3285 25.02 37.001 25.8175 37.001H26.2975V38.501C26.2975 39.331 26.945 40.001 27.74 40.001C28.535 40.001 29.1825 39.3285 29.1825 38.501V37.001H30.005V34.001H27.26V31.501H30.005V28.501H27.26V26.001H30.005V23.001H29.1825V21.501C29.1825 20.6735 28.5375 20.001 27.74 20.001Z"
            fill="#B4D2D7"
          />
        </svg>

        <div class="boxed">
          <form class="text-left" @submit.prevent="submit()">
            <!--request form-->
            <template v-if="step === 'requestForm'">
              <div class="text-center">
                <h2>Request Transfer</h2>
                <p>Fill in your transfer details below and submit</p>
              </div>
              <div class="form__flex">
                <div class="form__flex__item">
                  <Dropdown
                    title="Source Account"
                    :label="
                      modalRequestForm.source
                        ? displayBankDetails(modalRequestForm.source)
                        : 'Select Account'
                    "
                    :options="accountDropdownOptions"
                    :useModalDataToggle="false"
                    :onOptionSelected="
                      ({ payload }) => {
                        $v.modalRequestForm.source.$model =
                          payload.accountNumber;
                        modalRequestForm.source_bank = payload.bankCode;
                      }
                    "
                  />
                  <span
                    class="attention"
                    v-if="$v.modalRequestForm.source.$error"
                    >Field can't be empty</span
                  >
                </div>
              </div>

              <div class="form__flex">
                <div class="form__flex__item">
                  <Dropdown
                    title="Destination Account"
                    :label="
                      modalRequestForm.destination
                        ? displayBankDetails(modalRequestForm.destination)
                        : 'Select Account'
                    "
                    :options="accountDropdownOptions"
                    :useModalDataToggle="false"
                    :onOptionSelected="
                      ({ payload }) => {
                        $v.modalRequestForm.destination.$model =
                          payload.accountNumber;
                        modalRequestForm.destination_bank = payload.bankCode;
                      }
                    "
                  />
                  <span
                    class="attention"
                    v-if="$v.modalRequestForm.destination.$error"
                    >Field can't be empty</span
                  >
                </div>
              </div>

              <div class="form__flex">
                <div class="form__flex__item">
                  <label class="form__label text-danger" for>Amount</label>
                  <input
                    class="form__input"
                    type="text"
                    v-model.trim="$v.modalRequestForm.amount.$model"
                    v-money="mask"
                  />
                  <span
                    class="attention"
                    v-if="$v.modalRequestForm.amount.$error && submitAttempted"
                    >Field can't be empty</span
                  >
                </div>
              </div>

              <div class="form__flex">
                <div class="form__flex__item">
                  <label class="form__label text-danger" for>Narration</label>
                  <textarea
                    label="Add a note"
                    class="form__input"
                    v-model="$v.modalRequestForm.narration.$model"
                  />
                  <span
                    class="attention"
                    v-if="$v.modalRequestForm.narration.$error"
                    >Field can't be empty</span
                  >
                </div>
              </div>
            </template>

            <!--Summary-->
            <template v-else-if="step === 'summary'">
              <div class="text-center">
                <h2>Request Summary</h2>
                <p class="mb-4">
                  Confirm your transfer details below and submit
                </p>
              </div>

              <div class="details__card__item">
                <div class="details__card__item__left">
                  <div class="details__card__item__label">Source Account</div>
                  <div class="details__card__item__value">
                    {{ displayBankDetails(modalRequestForm.source) }}
                  </div>
                </div>
                <div class="details__card__item__right">
                  <div class="details__card__item__label">
                    Destination Account
                  </div>
                  <div class="details__card__item__value">
                    {{ displayBankDetails(modalRequestForm.destination) }}
                  </div>
                </div>
              </div>

              <div class="details__card__item">
                <div class="details__card__item__left">
                  <div class="details__card__item__label">
                    Requester's Email
                  </div>
                  <div class="details__card__item__value">
                    {{ userDetails.email }}
                  </div>
                </div>
                <div class="details__card__item__right">
                  <div class="details__card__item__label">Amount</div>
                  <div class="details__card__item__value">
                    ₦{{ formatMoneyMask(modalRequestForm.amount) }}
                  </div>
                </div>
              </div>

              <div class="details__card__item">
                <div class="details__card__item__left">
                  <div class="details__card__item__label">Narration</div>
                  <div class="details__card__item__value">
                    {{ modalRequestForm.narration }}
                  </div>
                </div>
              </div>
            </template>

            <template v-else-if="step === 'successfulRequest'">
              <div class="text-center">
                <h2>Request Successful</h2>
                <p class="mb-4">
                  Your request has been submitted. A reviewer will attend to
                  your request shortly.
                </p>
              </div>
            </template>

            <!--approval section-->

            <!--OTP-->
            <template v-if="step === 'sendOTP'">
              <div class="text-center">
                <h2>
                  {{
                    otpMethod === "email_otp"
                      ? "Sending OTP"
                      : "Preparing approval"
                  }}
                </h2>
                <div class="loader mx-auto py-4">
                  <span aria-hidden="true" class="spinner-border"></span>
                </div>
              </div>
            </template>

            <template v-if="step === 'OTPFailure'">
              <div class="text-center">
                <h2>Could not start approval</h2>
                <p class="mb-4">
                  Please try again or contact customer care if this persists.
                </p>
              </div>
            </template>

            <!--approve request-->
            <template v-if="step === 'approveRequest'">
              <div class="text-center">
                <h2>Approve Request</h2>
                <p class="mb-4">
                  {{
                    otpMethod === "email_otp"
                      ? "Please provide the OTP sent to you"
                      : "Please provide your authenticator code"
                  }}
                </p>
              </div>
              <authPin
                v-if="otpMethod === 'email_otp'"
                @complete="
                  (emittedPayload) => handlePinComplete(emittedPayload, 'otp')
                "
                title="Enter OTP"
                type="otp"
              />
              <authPin
                v-else-if="otpMethod === 'totp'"
                @complete="
                  (emittedPayload) => handlePinComplete(emittedPayload, 'totp')
                "
                type="totp"
              />
              <div class="form__flex">
                <div class="form__flex__item">
                  <label class="form__label text-danger" for
                    >Comment (Optional)</label
                  >
                  <textarea
                    label="Add a note"
                    class="form__input"
                    v-model="modalApproveForm.comment"
                  />
                </div>
              </div>
            </template>

            <template v-else-if="step === 'successfulApproval'">
              <div class="text-center">
                <h2>Approval Successful</h2>
                <p class="mb-4">
                  Request has been successfully approved and the funds have been
                  transferred
                </p>
              </div>
            </template>

            <!--reject request-->
            <template v-if="step === 'rejectRequest'">
              <div class="text-center">
                <h2>Reject Request</h2>
                <p class="mb-4">
                  Please provide a reason for declining the request
                </p>
              </div>

              <div class="form__flex">
                <div class="form__flex__item">
                  <label class="form__label text-danger" for>Comment</label>
                  <textarea
                    label="Add a note"
                    class="form__input"
                    v-model="$v.modalRejectionForm.comment.$model"
                  />
                  <span
                    class="attention"
                    v-if="$v.modalRejectionForm.comment.$error"
                    >Please provide a reason for rejecting this request</span
                  >
                </div>
              </div>
            </template>

            <template v-else-if="step === 'successfulRejection'">
              <div class="text-center">
                <h2>Request Rejected</h2>
                <p class="mb-4">
                  Request has been rejected and the reason has been stated.
                </p>
              </div>
            </template>

            <!--submit-->
            <div
              class="d-flex"
              v-if="!step.includes('successful') && !step.includes('OTP')"
            >
              <button
                class="btn btn--block mr-2"
                @click="step = 'requestForm'"
                v-if="step === 'summary'"
                :disabled="submitting"
              >
                Back
              </button>
              <button
                class="btn btn--primary"
                type="submit"
                :disabled="submitting"
              >
                {{ submitting ? "Processing..." : "Submit" }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </extend-modal>
  </div>
</template>

<script>
import emptyTransactions from "../../../components/emptytransactions";
import { formatAmount, formatMoneyMask } from "../../../lib/formatAmount";
import EmptyState from "@/components/empty-state.vue";
import AccountCard from "../../../components/accountcard";
import Pagination from "../../../components/pagination";
import ExtendModal from "../../../components/ExtendModal";
import { required } from "vuelidate/lib/validators";
import StatusIndicator from "../../../components/status-indicator";
import moment from "moment";
import {
  reactive,
  onBeforeMount,
  computed,
  watch,
  toRefs,
} from "@vue/composition-api";
import StatusIndicatorWithWords from "../../../components/statusIndicatorWithWords";
import Dropdown from "../../../components/dropdown";
import Textarea from "../../../components/textarea";
import authPin from "./authPin.vue";

export default {
  metaInfo: {
    title: "Transfers",
  },

  components: {
    Textarea,
    Dropdown,
    StatusIndicatorWithWords,
    StatusIndicator,
    ExtendModal,
    Pagination,
    AccountCard,
    emptyTransactions,
    EmptyState,
    authPin,
  },

  validations: {
    modalRequestForm: {
      source: {
        required,
      },
      destination: {
        required,
      },
      amount: {
        notEmpty: (value) => value !== "₦ 0.00",
      },
      narration: {
        required,
      },
    },

    modalApproveForm: {},

    modalRejectionForm: {
      comment: {
        required,
      },
    },
  },

  setup(props, { root }) {
    const store = root.$store;
    const userDetails = store.state.userDetails;
    const mask = {
      decimal: ".",
      thousands: ",",
      prefix: "₦ ",
      suffix: "",
      precision: 2,
      masked: false /* doesn't work with directive */,
    };

    // data
    const data = reactive({
      userDetails,
      showInitiateButton: userDetails.permissions.find(
        (permission) => permission === "admin_initiate_transfer"
      )
        ? true
        : false,
      showApproveButton: userDetails.permissions.find(
        (permission) => permission === "admin_approve_transfer"
      )
        ? true
        : false,
      tabSelected: "approvedRequests",
      collectionAccountsLoading: false,
      fetchingRequests: false,
      submitting: false,
      step: "requestForm",
      pageInfo: {},
      otp_code: null,
      otpMethod: null,
      filterList: {
        reference: root.$route.query.transaction_reference
          ? root.$route.query.transaction_reference
          : "",
        requester: root.$route.query.requester
          ? root.$route.query.requester
          : "",
        status: root.$route.query.status
          ? root.$route.query.status
          : "APPROVED",
        sourceAccountNumber: root.$route.query.source
          ? root.$route.query.source
          : "",
        destinationAccountNumber: root.$route.query.destination
          ? root.$route.query.destination
          : "",
        approvalDate: root.$route.query.approval_date
          ? root.$route.query.approval_date
          : "",
        requestDate: root.$route.query.request_date
          ? root.$route.query.request_date
          : "",
      },
      openFilters: false,
      submitAttempted: false,

      modalRequestForm: {
        source: "",
        source_bank: "",
        destination: "",
        destination_bank: "",
        amount: "",
        narration: "",
      },

      modalApproveForm: {
        OTP: "",
        comment: "",
        reference: "",
      },

      modalRejectionForm: {
        comment: "",
        reference: "",
      },

      showModal: false,
      collectionAccounts: [],
      summary: {},
      requests: null,

      statusGroup: [
        {
          id: "APPROVED",
          name: "Approved",
        },
        {
          id: "PENDING",
          name: "Pending",
        },
        {
          id: "DECLINED",
          name: "Declined",
        },
      ],
    });

    //mounted
    onBeforeMount(() => {
      if (!root.$route.query.request_status)
        root.$router.push(
          "/dashboard/transfers?page=1&request_status=APPROVED"
        );
      switchView();
      fetchCollectionAccounts();
    });

    //watchers
    watch(
      () => root.$route.fullPath,
      () => {
        switchView();
      }
    );

    //computed
    const noRequests = computed(() => {
      return (
        !data.fetchingRequests && (!data.requests || !data.requests.length)
      );
    });

    const loading = computed(() => {
      return data.fetchingRequests || data.collectionAccountsLoading;
    });

    const isMaker = computed(() => {
      return userDetails.permissions.find(
        (permission) => permission === "transfer_create"
      );
    });

    const accountDropdownOptions = computed(() => {
      if (data.collectionAccounts.length) {
        return data.collectionAccounts.map(
          ({ bankCode, bankName, accountNumber, id }) => {
            return {
              payload: { bankCode, accountNumber },
              id,
              value: `${bankName}`,
            };
          }
        );
      } else return [];
    });
    //methods
    const switchView = () => {
      clearFilter(true);

      switch (root.$route.query.request_status) {
        case "APPROVED":
          data.tabSelected = "approvedRequests";
          break;

        case "PENDING":
          data.tabSelected = "pendingRequests";
          break;

        case "DECLINED":
          data.tabSelected = "declinedRequests";
          break;
      }

      fetchTransferRequests();
    };

    const toggleModal = ($v) => {
      if ($v) clearForms($v);
      data.showModal = !data.showModal;
    };

    const toggleShowDateFilter = () => {
      data.showFilterDateInput = !data.showFilterDateInput;
    };
    const toggleFilters = () => {
      data.openFilters = !data.openFilters;
    };

    const triggerFilter = () => {
      let queryObject = {};
      if (data.filterList.reference) {
        queryObject.transaction_reference = data.filterList.reference.trim();
      }
      if (data.filterList.requester) {
        queryObject.requester = data.filterList.requester.trim();
      }
      if (data.filterList.status) {
        queryObject.request_status = data.filterList.status;
      }
      if (data.filterList.approvalDate) {
        queryObject.approval_date = moment(data.filterList.approvalDate).format(
          "YYYY-MM-DD"
        );
      }
      if (data.filterList.requestDate) {
        queryObject.request_date = moment(data.filterList.requestDate).format(
          "YYYY-MM-DD"
        );
      }
      if (data.filterList.sourceAccountNumber) {
        queryObject.source = data.filterList.sourceAccountNumber;
      }
      if (data.filterList.destinationAccountNumber) {
        queryObject.destination = data.filterList.destinationAccountNumber;
      }

      queryObject.page = 1;

      data.openFilters = false;
      //Route to page with query
      root.$router.push({
        path: "/dashboard/transfers",
        query: queryObject,
      });
    };

    const clearFilter = (stayOnPage) => {
      data.filterList = {
        reference: "",
        requester: "",
        sourceAccountNumber: "",
        destinationAccountNumber: "",
        status: "APPROVED",
        approvalDate: "",
        requestDate: "",
      };
      data.openFilters = false;
      if (stayOnPage) return;
      root.$router.push({
        path: "/dashboard/transfers?page=1&request_status=APPROVED",
      });
    };

    const displayBankDetails = (nuban, short = false) => {
      const details = data.collectionAccounts.find(
        (bank) => bank.accountNumber === nuban
      );

      if (short) {
        details ? `${details.bankName}` : "N/A";
      } else {
        return details
          ? `${details.bankName} (${details.accountNumber})`
          : "N/A";
      }
    };

    const fetchCollectionAccounts = async () => {
      data.collectionAccountsLoading = true;
      const { summary, accounts } = await store.dispatch(
        "getCollectionAccounts"
      );
      data.collectionAccounts = accounts;
      data.summary = summary;
      data.collectionAccountsLoading = false;
    };

    const fetchTransferRequests = async () => {
      data.fetchingRequests = true;
      const response = await store.dispatch(
        "getTransferRequests",
        root.$route.query
      );
      data.requests = response.data;
      data.pageInfo = response.pageInfo;
      data.fetchingRequests = false;
    };

    const openApproveModal = async ($v, reference) => {
      toggleModal($v);
      data.modalApproveForm.reference = reference;
      data.modalApproveForm.OTP = "";
      data.modalApproveForm.comment = "";
      data.otp_code = null;
      data.otpMethod = null;
      data.step = "sendOTP";

      const method = await store.dispatch("fetchOtpStatus");
      data.otpMethod = method || null;

      if (data.otpMethod === "email_otp") {
        const response = await store.dispatch("sendActionOtp");
        data.step = response ? "approveRequest" : "OTPFailure";
        return;
      }

      if (data.otpMethod === "totp") {
        data.step = "approveRequest";
        return;
      }

      data.step = "OTPFailure";
    };

    const openDeclineModal = async ($v, reference) => {
      toggleModal($v);
      data.modalRejectionForm.reference = reference;
      data.step = "rejectRequest";
    };

    const submitRequest = async () => {
      data.submitting = true;
      data.modalRequestForm.amount = formatMoneyMask(
        data.modalRequestForm.amount,
        false
      );
      const response = await store.dispatch(
        "submitTransferApprovalRequest",
        data.modalRequestForm
      );
      if (response) data.step = "successfulRequest";
      data.submitting = false;
      fetchTransferRequests();
    };

    const isApproveCodeValid = () => {
      if (data.otpMethod === "email_otp") {
        return (
          !!data.modalApproveForm.OTP && data.modalApproveForm.OTP.length === 6
        );
      }
      if (data.otpMethod === "totp") {
        return !!data.otp_code && data.otp_code.length === 6;
      }
      return false;
    };

    const approveRequest = async () => {
      data.submitting = true;
      const response = await store.dispatch("handleRequest", {
        action: "approve",
        data: data.modalApproveForm,
        totp_code: data.otp_code,
        otpMethod: data.otpMethod,
      });
      if (response) data.step = "successfulApproval";
      data.submitting = false;
      fetchTransferRequests();
    };

    const rejectRequest = async () => {
      data.submitting = true;
      const response = await store.dispatch("handleRequest", {
        action: "decline",
        data: data.modalRejectionForm,
      });
      if (response) data.step = "successfulRejection";
      data.submitting = false;
      fetchTransferRequests();
    };

    function clearForms($v) {
      data.submitAttempted = false;
      data.step = "requestForm";
      data.modalRequestForm = {
        source: "",
        destination: "",
        amount: "₦ 0.00",
        narration: "",
      };
      data.modalApproveForm = {
        OTP: "",
        comment: "",
        reference: "",
      };
      data.otp_code = null;
      data.otpMethod = null;
      $v.$reset();
    }
    const handlePinComplete = (val, type) => {
      if (type === "totp") {
        data.otp_code = val;
        return;
      } else if (type === "otp") {
        data.modalApproveForm.OTP = val;
        return;
      }
    };
    async function submit() {
      data.submitAttempted = true;
      switch (data.step) {
        // form step
        case "requestForm":
          this.$v.modalRequestForm.$touch();
          if (!this.$v.modalRequestForm.$invalid) {
            data.step = "summary";
            data.submitAttempted = false;
          }
          break;

        case "summary":
          await submitRequest();
          break;

        //approval section
        case "approveRequest":
          if (isApproveCodeValid()) {
            approveRequest();
            data.submitAttempted = false;
          }
          break;

        case "rejectRequest":
          this.$v.modalRejectionForm.$touch();
          if (!this.$v.modalRejectionForm.$invalid) {
            rejectRequest();
            data.submitAttempted = false;
          }
          break;
      }
    }

    return {
      ...toRefs(data),
      accountDropdownOptions,
      noRequests,
      loading,
      isMaker,
      switchView,
      moment,
      toggleModal,
      clearForms,
      formatAmount,
      formatMoneyMask,
      toggleShowDateFilter,
      toggleFilters,
      triggerFilter,
      clearFilter,
      displayBankDetails,
      openApproveModal,
      openDeclineModal,
      fetchTransferRequests,
      submit,
      mask,
      handlePinComplete,
    };
  },
};
</script>

<style lang="scss" scoped>
// filter styles start
.relative {
  position: relative;
}

.rotate {
  transform: rotate(180deg);
}

.woven-color {
  background: #e00b5b;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  height: 40px;

  svg {
    margin-right: 5px;
  }

  .btn--text {
    font-style: normal;
    font-weight: 500;
    color: #fff;
    width: 100%;
    text-align: center;
  }
}

.woven-border-only {
  background: #fff;
  border: 1px solid #e00b5b;
  height: 40px;

  svg {
    margin-left: 5px;
  }

  .btn--text {
    font-style: normal;
    font-weight: 500;
    text-align: center;
    color: #e00b5b;
  }
}

.filter-dropdown {
  background: #fff;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 30px;
  left: 145px;

  .form__item {
    margin-bottom: 16px;
  }
}

.woven-red {
  color: #e00b5b;
}

.button-group {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  margin-top: 32px;
  border-top: 1px solid rgba(196, 196, 196, 0.5);

  p {
    width: 100%;
  }

  .btn {
    width: 100px;
    height: 40px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    padding: 10px;
    text-align: center;
  }
}

.date-group {
  display: flex;
}

.margin-right {
  margin-right: 16px;
}

.date {
  border: 0.5px solid rgba(97, 110, 124, 0.5);
  box-sizing: border-box;
  border-radius: 4px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: rgba(97, 110, 124, 0.8);
  padding: 12px 10px;
  max-width: 112px;
}

.status-element {
  display: flex;

  svg {
    margin-right: 10px;
    cursor: pointer;
  }
}

.text-light {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #595959;

  span {
    color: #e00b5b;
    cursor: pointer;
  }
}

.filter-title {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 14px;
  color: #9a9fa3;
  margin-bottom: 16px;
}

// filter styles end

.empty__text {
  &__caption {
    max-width: 300px;
    line-height: 24px;
  }
}
.toggle-date {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  color: #595959;
  text-transform: capitalize !important;
  display: flex;
  .date {
    margin: 0 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */

    color: #e00b5b;
    cursor: pointer;
  }
}
.btn-filter {
  height: 50px;

  border: 1px solid #fd8387;
  box-sizing: border-box;
  border-radius: 4px;
  background: transparent !important;
}
</style>

<style lang="scss" scoped>
.page__title__action .btn--primary {
  padding-left: 4rem;
  padding-right: 4rem;
}
.modal-body {
  justify-content: center !important;
  h2 {
    font-weight: 500;
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 14px;
  }

  p {
    margin-bottom: 31px;
    color: #616e7c;
  }

  svg {
    margin-bottom: 12px;
  }

  textarea {
    resize: none;
    height: 4rem;
  }

  .boxed {
    width: 50%;
    margin: 0.5rem auto 1.5rem;
    .form__flex__item,
    button {
      margin-left: 0;
      width: 100%;
    }

    .details__card__item {
      padding: 0 0 24px;
      border: none;
    }
  }
}

.dropdown-item-list {
  display: flex;
  align-items: center;
  span {
    display: inline;
    padding-left: 10px;
  }
}

.btn .dropdown-toggle .btn-secondary .btn-sm {
  color: #b59b01;
}

.green,
.green:hover {
  color: #15ce9a !important;
}

.list {
  width: 100%;
}

.tab__content {
  width: 100%;
  overflow-x: auto;
}

.justify-content-center {
  justify-content: center;
}

.overview {
  overflow-x: auto;
  &::-webkit-scrollbar {
    display: none;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  display: flex;
  margin-bottom: 32px;
  .account {
    min-width: 23.5%;
  }
  &__item {
    background: #ffffff;
    box-sizing: border-box;
    box-shadow: 0px 8px 10px rgba(255, 255, 255, 0.05);
    border-radius: 6px;
    flex-basis: 50%;
    text-align: center;
    &:last-child {
      margin-left: 32px;
    }

    &__top {
      padding: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
    }

    &__bottom {
      padding: 27px 24px 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      border-top: 1px solid #ebf0f4;
    }

    &__value {
      font-size: 36px;
      line-height: 43px;
      margin-bottom: 13px;
    }

    &__caption {
      color: rgba(38, 25, 64, 0.7);
      font-size: 14px;
      margin-bottom: 15px;
    }

    &__action {
      color: #e00b5b;
      a {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 14px;
        /* identical to box height, or 87% */

        color: #e00b5b;
        text-decoration: none;
        text-transform: capitalize;
      }

      svg {
        margin-top: -10px;
        display: inline-block;
      }
    }

    &__number {
      color: rgba(38, 25, 64, 0.7);
    }
  }
}

.name {
  color: #261940;
  display: block;
  margin-bottom: 4px;
}

.email {
  color: rgba(38, 25, 64, 0.6);
  font-size: 12px;
}
</style>

<style lang="scss">
.page {
  z-index: 1000 !important;
}
.sudo-modal {
  min-width: 50% !important;
  display: block !important;
  padding-bottom: 0 !important;
  &__content {
    display: block !important;
    position: relative;
  }
}
.tag.no-bg {
  padding: 0 !important;
}

.account .amount span {
  font-size: 24px !important;
}
</style>
